export const XCityActionSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_219_441)">
        <circle cx="8" cy="7" r="7" fill="url(#paint0_linear_219_441)" />
      </g>
      <defs>
        <filter
          id="filter0_d_219_441"
          x="0"
          y="0"
          width="16"
          height="16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_441"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_441"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_219_441"
          x1="8"
          y1="0"
          x2="8"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#848BC3" />
          <stop offset="0.276042" stopColor="#6377C2" />
          <stop offset="0.479167" stopColor="#5770C2" />
          <stop offset="0.682292" stopColor="#5E73BE" />
          <stop offset="1" stopColor="#757DB2" />
        </linearGradient>
      </defs>
    </svg>
  );
};
